module.exports = __webpack_public_path__ + "img/ic_20_google.1d33f54b.svg";